import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Stack, Typography } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const structuralGrey = '#E0E0E0';
const textBlack = '#050505';
const textGrey = '#666666';

const opportunityTracks = [
  {
    title: 'Talent Acquisition',
    description:
      'Atração e seleção com clareza de critérios, ritmo de execução e boa experiência para candidatos.'
  },
  {
    title: 'People Operations',
    description:
      'Estruturação de rotinas, processos e acompanhamento operacional da jornada de pessoas.'
  },
  {
    title: 'Cultura e Desenvolvimento',
    description:
      'Apoio a rituais, desenvolvimento, performance e evolução da operação com consistência.'
  }
];

const actionButtonSx = {
  borderRadius: '14px',
  px: 3.5,
  py: 1.4,
  color: textBlack,
  borderColor: textBlack,
  fontFamily: '"JetBrains Mono", monospace',
  fontWeight: 600,
  textTransform: 'none',
  borderWidth: '1px',
  '&:hover': {
    bgcolor: 'rgba(0, 0, 0, 0.04)',
    borderColor: textBlack,
    borderWidth: '1px'
  },
  transition: 'all 0.2s ease-in-out'
};

const CareersPage = () => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        overflow: 'hidden',
        bgcolor: '#FAFAFA',
        color: textBlack,
        position: 'relative'
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          opacity: 0.5,
          pointerEvents: 'none',
          backgroundImage: `linear-gradient(${structuralGrey} 1px, transparent 1px), linear-gradient(90deg, ${structuralGrey} 1px, transparent 1px)`,
          backgroundSize: '40px 40px',
          zIndex: 0
        }}
      />

      <Box
        sx={{
          width: { xs: '100%', md: '44%' },
          borderRight: { xs: 'none', md: `1px solid ${structuralGrey}` },
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          p: { xs: 3, md: 5 },
          position: 'relative',
          zIndex: 1,
          overflowY: 'auto'
        }}
      >
        <Stack spacing={3}>
          <Box>
            <Typography
              variant="overline"
              sx={{
                fontFamily: 'JetBrains Mono',
                color: textGrey,
                letterSpacing: '0.2em',
                fontWeight: 600
              }}
            >
              R5 OPORTUNIDADES
            </Typography>
            <Typography
              variant="h1"
              sx={{
                fontSize: { xs: '2.8rem', md: '4.2rem' },
                fontWeight: 800,
                lineHeight: 0.9,
                letterSpacing: '-0.05em',
                color: textBlack,
                mt: 1
              }}
            >
              ESTAMOS<br />
              CONTRATANDO<span style={{ color: '#CC0000' }}>_</span>
            </Typography>
          </Box>

          <Typography
            variant="body1"
            sx={{
              color: textGrey,
              maxWidth: '420px',
              lineHeight: 1.75,
              fontFamily: '"JetBrains Mono", monospace'
            }}
          >
            Conheça as vagas disponíveis.
          </Typography>

          <Box sx={{ pt: 2, borderTop: `1px solid ${structuralGrey}` }}>
            <Typography
              variant="caption"
              sx={{ color: textGrey, display: 'block', mb: 1, fontFamily: 'JetBrains Mono' }}
            >
              FRENTE ATUAL
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: textBlack,
                maxWidth: '320px',
                lineHeight: 1.7,
                fontFamily: '"JetBrains Mono", monospace',
                fontWeight: 500
              }}
            >
              Gestão de Pessoas
              <br />
              Recursos Humanos
            </Typography>
          </Box>
        </Stack>
      </Box>

      <Box
        sx={{
          width: { xs: '100%', md: '56%' },
          bgcolor: '#FFFFFF',
          position: 'relative',
          zIndex: 1,
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'auto'
        }}
      >
        <Box
          sx={{
            p: { xs: 3, md: 6 },
            display: 'flex',
            flexDirection: 'column',
            gap: 3
          }}
        >
          <Box>
            <Typography
              variant="caption"
              sx={{
                fontFamily: 'JetBrains Mono',
                color: textBlack,
                textTransform: 'uppercase',
                letterSpacing: '0.1em',
                fontWeight: 600
              }}
            >
              Frentes de atuação
            </Typography>
          </Box>

          {opportunityTracks.map((track) => (
            <Box
              key={track.title}
              sx={{
                border: `1px solid ${structuralGrey}`,
                borderRadius: '14px',
                bgcolor: '#F5F5F5',
                p: 3
              }}
            >
              <Typography variant="h6" sx={{ color: textBlack, fontWeight: 700, mb: 1.25 }}>
                {track.title}
              </Typography>
              <Typography variant="body2" sx={{ color: textGrey, lineHeight: 1.7 }}>
                {track.description}
              </Typography>
            </Box>
          ))}
        </Box>

        <Box
          sx={{
            borderTop: `1px solid ${structuralGrey}`,
            py: 4,
            px: { xs: 3, md: 6 },
            flexShrink: 0
          }}
        >
          <Stack spacing={2} alignItems="flex-start">
            <Typography variant="h6" sx={{ color: textBlack, fontWeight: 700 }}>
              Manifestar interesse
            </Typography>
            <Typography variant="body2" sx={{ color: textGrey, lineHeight: 1.7, maxWidth: '520px' }}>
              Se você se identifica com essa frente, entre em contato com a R5 para iniciar a conversa.
            </Typography>
            <Button
              component={RouterLink}
              to="/fale-conosco"
              variant="outlined"
              endIcon={<ArrowForwardIcon />}
              sx={actionButtonSx}
            >
              Fale com a R5
            </Button>
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};

export default CareersPage;
